const Constants = {
    MEMORY_FIRST_NAME_KEY: 'memory-first-name',
    MEMORY_GAMES_KEY: 'memory-games',
    MEMORY_SIGNED_UP_MESSAGE_KEY: 'memory-games-signed-up-message',
    EMAIL_SIGN_UP: process.env.REACT_APP_EMAIL_SIGN_UP === 'true',
};

export default Constants;
